import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/hotel-portal'),
    component: Index,
    name: 'hotel_portal_list',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
